/*
 * @Descripttion:
 * @Author: 陈文湘
 * @Date: 2020-07-01 17:28:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-07-22 08:45:19
 * @FilePath: \dzCloudc:\Users\Administrator\Documents\kuaio\src\main.js
 */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueClipboard from "vue-clipboard2";
import md5 from "js-md5";
Vue.use(VueClipboard);

import "./plugins/directive/permission";
import "./plugins/directive/paste";
import "./plugins/directive/onlyNumber";
import "./plugins/element";
import "./plugins/axios";
import "@/assets/js/utils.js";
import "@/plugins/filters.js";
import "@/plugins/checkLogin.js";

// import "./styles/iconfont.js";
import "./styles/dz-minx.scss";
import "./styles/symbolIcon.css";
// TODO:上线前开启这里 系统错误捕获
const errorHandler = (error, vm, info) => {
  let logTime = new Date();
  let userInfo = localStorage.getItem("userInfo");
  userInfo = JSON.parse(userInfo);
  let data = {
    userid: userInfo ? userInfo.token : "身份游客暂无token",
    level: "4", //日志等级
    projectName: "kuaio", //项目名称
    message: String(error.message), //日志标题信息(255字节)
    detailTrace: String(error.stack), //日志细节跟踪
    logTime: vm.$utils.formatTime(logTime, "yyyy-MM-dd hh:mm:ss"), //日志记录时间
    requestUrl: "", //请求地址
    params: "", //请求参数
    func: "快哦前端JS",
  };
  // TODO:上线前开启这里
  // vm.$ajax.post("/logmanage/api/Log/Add", data).then(function(res) {
  //   // console.log(res)
  // });
  vm.$ajax.post("/logmanage/api/Log/Add", data).then(function(res) {
    // console.log(res)
  });
  // console.error();
};

// Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error) => {
  errorHandler(error, this);
};

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;

import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 100,
  maxWidth: "60%",
});

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});

import Meta from "vue-meta";
Vue.use(Meta);
new Vue({
  router,
  data: {
    title: "快哦",
    keywords: "",
    description: "",
  },
  //定义metaInfo
  metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords,
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description,
        },
      ],
    };
  },
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
}).$mount("#app");
